var LoyaltyCardType = /* @__PURE__ */ ((LoyaltyCardType2) => {
  LoyaltyCardType2["LUHN"] = "LUHN";
  LoyaltyCardType2["UUID"] = "UUID";
  return LoyaltyCardType2;
})(LoyaltyCardType || {});
export {
  LoyaltyCardType
};
//# sourceMappingURL=types.js.map
